import { Navigate, useSearchParams } from 'react-router-dom';

import { ROUTES } from './routes';

/**
 * Hook that checks for policy redirect query parameter.
 * If necessary, it will automatically navigate to the appropriate policy page.
 */
export function usePolicyRedirect() {
  const [searchParams] = useSearchParams();
  const policy = searchParams.get('policy');

  if (policy === 'terms-of-service') {
    return <Navigate to={ROUTES.TERMS_PAGE.path} replace />;
  }

  return null;
}

/**
 * Component that redirects ?policy=terms-of-service to /terms page.
 *
 * This supports legacy URLs that external systems may still use.
 * Uses `replace` to avoid polluting browser history.
 *
 * @param {{ children: React.ReactNode }} props
 */
export function PolicyRedirectGuard({ children }) {
  const redirect = usePolicyRedirect();

  if (redirect) {
    return redirect;
  }

  return children;
}
